import axios from "axios";
import { getCookie } from "@lib/utils";
import { userService } from "@entities";

// Один общий промис на все параллельные 401. Refresh-токен РОТИРУЕТСЯ при каждом вызове,
// поэтому без дедупликации несколько одновременно упавших запросов запускали бы несколько
// /refresh, и «проигравшие» получали бы уже протухший токен — самоподдерживающийся цикл 401.
// Ту же гонку мы уже ловили и чинили в расширении (refreshTokenOnce в app/background.js).
let refreshPromise = null;

const refreshTokenOnce = () => {
  if (!refreshPromise) {
    refreshPromise = userService
      .refreshToken()
      .finally(() => { refreshPromise = null; });
  }

  return refreshPromise;
};

class BaseService {
  baseURL;
  instance;

  constructor() {
    this.baseURL = process.env.REACT_APP_BASE_URL;

    this.instance = axios.create({
      baseURL: this.baseURL,
      withCredentials: true,
    });

    this.instance.defaults.withCredentials = true;
  }

  generateQueryString(props) {
    props = props || {};

    if (typeof props === "string" || props instanceof String) {
      return props.replace("?", "");
    }

    if (Array.isArray(props)) {
      props = Object.reduce(
        (result, prop) => Object.assign(result, prop),
        props
      );
    }

    return new URLSearchParams(props);

    // let queryString = '';
    // let keysArray = [];

    // if (Array.isArray(props)) {
    //   keysArray = props;
    // } else {
    //   const keys = Object.keys(props);
    //   keys.forEach((key) => keysArray.push({ [key]: props[key] }));
    // }

    // keysArray.forEach((item, indx) => {
    //   const itemKey = Object.keys(item);

    //   queryString = queryString.concat(itemKey, '=', item[itemKey]);

    //   if (indx !== keysArray.length - 1) {
    //     queryString = queryString.concat('&');
    //   }
    // });

    // return queryString;
  }
}
export class ApiService extends BaseService {
  constructor() {
    super();

    try {
      this.instance.interceptors.request.use(this.authInterceptor);
      this.instance.interceptors.response.use(
        this.handleResponseInterceptor,
        // bind обязателен: обработчику нужен this.instance, чтобы ПОВТОРИТЬ запрос после
        // обновления токена. Без привязки this внутри интерцептора undefined.
        this.handleResponseInterceptorError.bind(this)
      );
    } catch (e) {}
  }

  authInterceptor(config) {
    const setHeaders = () => {
      const contentType = "application/json";

      const isFormData =
        config.headers["Content-Type"] === "multipart/form-data" && true;

      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "CSRF-Token": `${getCookie("XSRF-TOKEN") || ""}`,
      };

      if (!isFormData) {
        headers["Accept"] = contentType;
        headers["Content-Type"] = contentType;
      }

      return headers;
    };

    config.headers = setHeaders();

    return config;
  }

  handleResponseInterceptor(response) {
    return response;
  }

  async handleResponseInterceptorError(error) {
    const status = error?.response?.status || null;

    if (!status) {
      throw new Error("Status in response not found");
    }

    switch (status) {
      case 500:
        //alert ("500")
        break;
      case 400:
        throw error;
      case 401: {
        const originalRequest = error.config || {};

        // Повторяем РОВНО ОДИН раз: если и после обновления токена снова 401, значит сессии
        // действительно нет, и дальше был бы бесконечный цикл запрос → 401 → refresh → запрос.
        if (originalRequest._retry) {
          throw error;
        }
        originalRequest._retry = true;

        await refreshTokenOnce();

        // Повтор через тот же instance: его request-интерцептор заново прочитает localStorage
        // и подставит уже обновлённый токен. Раньше здесь стоял break — токен обновлялся, но
        // запрос не повторялся, и промис разрешался значением undefined: вызывающий код
        // получал пустоту вместо данных. Именно поэтому помогала только полная перезагрузка
        // страницы (при старте App.js делает await checkAuthTC() до первого рендера).
        return this.instance(originalRequest);
      }

      //case 404:
      //window.location.replace("/404");
      //  break;

      case 403:
        throw error;

      default:
        throw error;
    }

    return;
  }

  setFormDataInterceptors() {
    this.instance.interceptors.request.use((config) => {
      config.headers["Content-Type"] = "multipart/form-data";
      config.headers["Accept"] = "multipart/form-data";

      return config;
    });
  }

  getFormData(data) {
    if (!(data instanceof FormData)) {
      const _formData = new FormData();

      Object.keys(data).forEach((key) => {
        const value =
          data[key] instanceof Array ? JSON.stringify(data[key]) : data[key];

        _formData.set(key, value);
      });

      return _formData;
    }

    return data;
  }
}
